<template>
  <el-dialog
      :title="$t('socialPosts.create.deletePlanifBrouillons.title')"
      :visible.sync="modalDeletePlanifBrouillons"
      v-loading="loadingStatus"
      width="45%"
      @close="closeModal">
        <span class="text-left">
          {{ $t('socialPosts.create.deletePlanifBrouillons.message')}}
        </span>
    <span slot="footer" class="dialog-footer">
          <el-button type="success" @click="confirm()">{{ $t('socialPosts.create.deletePlanifBrouillons.confirm')}}</el-button>
          <el-button @click="closeModal()">{{ $t('socialPosts.create.deletePlanifBrouillons.cancel')}}</el-button>
        </span>
  </el-dialog>
</template>

<script>

import { mapActions, mapMutations, mapState } from 'vuex'

export default {
  name: 'DialogDeletePlanifBrouillon',
  computed: {
    ...mapState('socialPostsCreationPostEditorial', [
      'modalDeletePlanifBrouillons',
      'loadingStatus'])
  },
  methods: {
    ...mapMutations('socialPostsCreationPostEditorial',
      ['SET_MODAL_DELETE_PLANIF_BROUILLONS']),
    ...mapActions('socialPostsCreationPostEditorial',
      ['validatePost']),
    async confirm () {
      try {
        await this.validatePost({ typePost: 'B' })
        this.SET_MODAL_DELETE_PLANIF_BROUILLONS(false)
        // Émettre un événement pour informer le parent que l'action est terminée
        this.$emit('draft-saved')
      } catch (error) {
        console.error('Erreur lors de la sauvegarde du brouillon:', error)
        // Émettre un événement d'erreur
        this.$emit('draft-error', error)
      }
    },
    closeModal () {
      this.SET_MODAL_DELETE_PLANIF_BROUILLONS(false)
      // Émettre un événement pour informer le parent que l'action est annulée
      this.$emit('draft-cancelled')
    }
  }
}
</script>

<style>

</style>
